export enum GeocodeVersion {
  V1,
  V2
}
